import { axios } from "@cores/axiosWrapper";

export const getReportSettingsAPI = (stageId, apiEndpoint, projectId, params) => {
    const headers = {
        stageId,
    };
    if (projectId) {
        headers.projectId = projectId;
    }
    //
    // return {
    //     data: {
    //         results: [
    //             {
    //                 id: "report_12345",
    //                 name: "Monthly Sales Report",
    //                 notification: {
    //                     type: "EMAIL",
    //                     status: "ACTIVE",
    //                     cycle: "매주 - 월요일 - 오전 10시 발송 (UTC+9)",
    //                 },
    //                 targets: ["ASSET_CREATION", "ASSET_DELETION"],
    //             },
    //         ],
    //         nextToken: null,
    //     },
    // };

    return axios.get(`${apiEndpoint}/report-settings`, {
        headers,
        params,
    });
};

export const getReportSettingAPI = (stageId, apiEndpoint, projectId, id, params) => {
    const headers = {
        stageId,
    };
    if (projectId) {
        headers.projectId = projectId;
    }
    return axios.get(`${apiEndpoint}/report-settings/${id}`, {
        headers,
        params,
    });
};

export const getReportsAPI = (stageId, apiEndpoint, projectId, params) => {
    const headers = {
        stageId,
    };
    if (projectId) {
        headers.projectId = projectId;
    }

    return axios.get(`${apiEndpoint}/reports`, {
        headers,
        params,
    });
};

export const updateReportSettingsAPI = (stageId, apiEndpoint, projectId, id, data) => {
    const headers = {
        stageId,
    };
    if (projectId) {
        headers.projectId = projectId;
    }

    return axios.patch(`${apiEndpoint}/report-settings/${id}`, data, {
        headers,
    });
};
